import { useEffect, useState } from 'react';
import { monthRange, normalizeShipping } from './shipping-data';

export function useShippingData({ apiBaseUrl, company, year, month, refreshSignal, dataInicial, dataFinal }) {
  const range = dataInicial && dataFinal ? { dataInicial, dataFinal } : monthRange(year, month);
  const start = range.dataInicial, end = range.dataFinal;
  const key = `${apiBaseUrl}|${company}|${start}|${end}|${refreshSignal}`;
  const [state, setState] = useState({ key: '', rows: [], loading: true, error: '' });
  useEffect(() => {
    const controller = new AbortController();
    setState({ key, rows: [], loading: true, error: '' });
    async function load() {
      try {
        const token = localStorage.getItem('@user_token');
        if (!token) throw new Error('Sua sessão expirou. Faça login novamente.');
        const query = new URLSearchParams({ dataInicial: start, dataFinal: end });
        if (company) query.set('empresa', company);
        const response = await fetch(`${apiBaseUrl.replace(/\/$/, '')}/api/dashboard/expedicao/grafico?${query}`, {
          headers: { Authorization: `Bearer ${token}` }, signal: controller.signal,
        });
        if (!response.ok) {
          const messages = { 401: 'Sua sessão expirou. Faça login novamente.', 403: 'Você não tem permissão para consultar a expedição.',
            429: 'Muitas consultas. Aguarde e tente novamente.' };
          throw new Error(messages[response.status] || 'Não foi possível consultar a expedição. Tente novamente.');
        }
        const data = response.status === 204 ? [] : await response.json();
        if (!Array.isArray(data)) throw new Error('A API retornou uma lista de expedição inválida.');
        const rows = data.map(normalizeShipping);
        if (!controller.signal.aborted) setState({ key, rows, loading: false, error: '' });
      } catch (error) {
        if (!controller.signal.aborted) setState({ key, rows: [], loading: false, error: error.message });
      }
    }
    load();
    return () => controller.abort();
  }, [apiBaseUrl, company, start, end, refreshSignal, key]);
  return state.key === key ? state : { rows: [], loading: true, error: '' };
}
